import { render, staticRenderFns } from "./teamDetails.vue?vue&type=template&id=6a64462e&scoped=true&"
import script from "./teamDetails.vue?vue&type=script&lang=js&"
export * from "./teamDetails.vue?vue&type=script&lang=js&"
import style0 from "./teamDetails.vue?vue&type=style&index=0&id=6a64462e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a64462e",
  null
  
)

export default component.exports